// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-manage {

    width: 100%;
}





/* =========================
   검색
========================= */

.comment-search-wrap {

    margin-bottom: 20px;
}





.comment-search-input {

    width: 320px;

    height: 44px;

    padding: 0 18px;

    border-radius: 14px;

    border: 1px solid rgba(255,255,255,0.08);

    background:
            rgba(255,255,255,0.04);

    color: white;

    font-size: 14px;

    outline: none;
}





.comment-search-input::placeholder {

    color:
            rgba(255,255,255,0.35);
}





/* =========================
   헤더
========================= */

.comment-table-header {

    display: grid;

    grid-template-columns:
            70px
            1.4fr
            1.6fr
            120px
            180px
            100px;

    align-items: center;

    padding: 18px 20px;

    border-radius: 20px;

    background:

            linear-gradient(

                    135deg,

                    rgba(255,255,255,0.05),

                    rgba(255,255,255,0.02)
            );

    border:

            1px solid
            rgba(255,255,255,0.06);

    color:

            rgba(255,255,255,0.7);

    font-size: 14px;

    font-weight: 700;

    margin-bottom: 14px;
}





/* =========================
   리스트
========================= */

.comment-table {

    display: flex;

    flex-direction: column;

    gap: 14px;
}





.comment-row {

    display: grid;

    grid-template-columns:
            70px
            1.4fr
            1.6fr
            120px
            180px
            100px;

    align-items: center;

    gap: 14px;

    padding: 22px;

    border-radius: 24px;

    background:

            linear-gradient(

                    135deg,

                    rgba(255,255,255,0.05),

                    rgba(0,153,255,0.05)
            );

    border:

            1px solid
            rgba(255,255,255,0.05);

    transition: 0.25s;
}





.comment-row:hover {

    transform: translateY(-2px);

    border-color:

            rgba(122,92,255,0.35);
}





.comment-id {

    color: white;

    font-size: 22px;

    font-weight: 800;
}





.comment-content {

    color: white;

    font-size: 15px;

    line-height: 1.7;

    word-break: break-word;
}





.comment-post {

    color:

            rgba(255,255,255,0.7);

    font-size: 14px;

    line-height: 1.6;
}





.comment-writer {

    color: white;

    font-size: 14px;

    font-weight: 700;
}





.comment-date {

    color:

            rgba(255,255,255,0.55);

    font-size: 13px;
}





.comment-action {

    display: flex;

    justify-content: flex-start;
}





.comment-delete-button {

    min-width: 72px;

    height: 40px;

    border: none;

    border-radius: 999px;

    background:

            linear-gradient(
                    135deg,
                    #ff4d4d,
                    #ff2f2f
            );

    color: white;

    font-size: 13px;

    font-weight: 700;

    cursor: pointer;

    transition: 0.25s;
}





.comment-delete-button:hover {

    transform: translateY(-2px);
}





/* =========================
   페이지네이션
========================= */

.pagination-wrap {

    display: flex;

    justify-content: center;

    align-items: center;

    gap: 10px;

    margin-top: 34px;

    flex-wrap: wrap;
}





.page-button {

    min-width: 44px;

    height: 44px;

    border-radius: 14px;

    border:

            1px solid
            rgba(255,255,255,0.06);

    background:

            rgba(255,255,255,0.04);

    color:

            rgba(255,255,255,0.7);

    font-size: 13px;

    font-weight: 700;

    cursor: pointer;

    transition: 0.25s;
}





.page-button.active {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #60a5fa
            );

    color: white;

    border-color: transparent;
}





/* =========================
   Tablet
========================= */

@media (max-width: 1024px) {

    .comment-table-header,

    .comment-row {

        grid-template-columns:
                60px
                1.2fr
                1.4fr
                90px
                140px
                90px;
    }
}





/* =========================
   Mobile
========================= */

@media (max-width: 768px) {

    .comment-search-input {

        width: 100%;
    }





    .comment-table-header {

        display: none;
    }





    .comment-row {

        display: flex;

        flex-direction: column;

        align-items: flex-start;

        gap: 16px;

        padding: 20px;
    }





    .comment-id {

        font-size: 20px;
    }





    .comment-content {

        width: 100%;
    }





    .comment-post {

        width: 100%;
    }





    .comment-action {

        width: 100%;
    }





    .comment-delete-button {

        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CommentManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,mBAAmB;AACvB;;;;;;AAMA;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,wCAAwC;;IAExC;kCAC8B;;IAE9B,YAAY;;IAEZ,eAAe;;IAEf,aAAa;AACjB;;;;;;AAMA;;IAEI;kCAC8B;AAClC;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb;;;;;;iBAMa;;IAEb,mBAAmB;;IAEnB,kBAAkB;;IAElB,mBAAmB;;IAEnB;;;;;;;;;aASS;;IAET;;;kCAG8B;;IAE9B;;iCAE6B;;IAE7B,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;AACvB;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;;;;;AAMA;;IAEI,aAAa;;IAEb;;;;;;iBAMa;;IAEb,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;;;;aASS;;IAET;;;kCAG8B;;IAE9B,iBAAiB;AACrB;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;iCAE6B;AACjC;;;;;;AAMA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,sBAAsB;AAC1B;;;;;;AAMA;;IAEI;;iCAE6B;;IAE7B,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI;;kCAE8B;;IAE9B,eAAe;AACnB;;;;;;AAMA;;IAEI,aAAa;;IAEb,2BAA2B;AAC/B;;;;;;AAMA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,YAAY;;IAEZ,oBAAoB;;IAEpB;;;;;;aAMS;;IAET,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,iBAAiB;AACrB;;;;;;AAMA;;IAEI,2BAA2B;AAC/B;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,uBAAuB;;IAEvB,mBAAmB;;IAEnB,SAAS;;IAET,gBAAgB;;IAEhB,eAAe;AACnB;;;;;;AAMA;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB;;;kCAG8B;;IAE9B;;kCAE8B;;IAE9B;;iCAE6B;;IAE7B,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,iBAAiB;AACrB;;;;;;AAMA;;IAEI;;;;;;aAMS;;IAET,YAAY;;IAEZ,yBAAyB;AAC7B;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI;;;;QAII;;;;;;oBAMY;IAChB;AACJ;;;;;;AAMA;;2BAE2B;;AAE3B;;IAEI;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,aAAa;IACjB;;;;;;IAMA;;QAEI,aAAa;;QAEb,sBAAsB;;QAEtB,uBAAuB;;QAEvB,SAAS;;QAET,aAAa;IACjB;;;;;;IAMA;;QAEI,eAAe;IACnB;;;;;;IAMA;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,WAAW;IACf;AACJ","sourcesContent":[".comment-manage {\n\n    width: 100%;\n}\n\n\n\n\n\n/* =========================\n   검색\n========================= */\n\n.comment-search-wrap {\n\n    margin-bottom: 20px;\n}\n\n\n\n\n\n.comment-search-input {\n\n    width: 320px;\n\n    height: 44px;\n\n    padding: 0 18px;\n\n    border-radius: 14px;\n\n    border: 1px solid rgba(255,255,255,0.08);\n\n    background:\n            rgba(255,255,255,0.04);\n\n    color: white;\n\n    font-size: 14px;\n\n    outline: none;\n}\n\n\n\n\n\n.comment-search-input::placeholder {\n\n    color:\n            rgba(255,255,255,0.35);\n}\n\n\n\n\n\n/* =========================\n   헤더\n========================= */\n\n.comment-table-header {\n\n    display: grid;\n\n    grid-template-columns:\n            70px\n            1.4fr\n            1.6fr\n            120px\n            180px\n            100px;\n\n    align-items: center;\n\n    padding: 18px 20px;\n\n    border-radius: 20px;\n\n    background:\n\n            linear-gradient(\n\n                    135deg,\n\n                    rgba(255,255,255,0.05),\n\n                    rgba(255,255,255,0.02)\n            );\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.06);\n\n    color:\n\n            rgba(255,255,255,0.7);\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    margin-bottom: 14px;\n}\n\n\n\n\n\n/* =========================\n   리스트\n========================= */\n\n.comment-table {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 14px;\n}\n\n\n\n\n\n.comment-row {\n\n    display: grid;\n\n    grid-template-columns:\n            70px\n            1.4fr\n            1.6fr\n            120px\n            180px\n            100px;\n\n    align-items: center;\n\n    gap: 14px;\n\n    padding: 22px;\n\n    border-radius: 24px;\n\n    background:\n\n            linear-gradient(\n\n                    135deg,\n\n                    rgba(255,255,255,0.05),\n\n                    rgba(0,153,255,0.05)\n            );\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.05);\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.comment-row:hover {\n\n    transform: translateY(-2px);\n\n    border-color:\n\n            rgba(122,92,255,0.35);\n}\n\n\n\n\n\n.comment-id {\n\n    color: white;\n\n    font-size: 22px;\n\n    font-weight: 800;\n}\n\n\n\n\n\n.comment-content {\n\n    color: white;\n\n    font-size: 15px;\n\n    line-height: 1.7;\n\n    word-break: break-word;\n}\n\n\n\n\n\n.comment-post {\n\n    color:\n\n            rgba(255,255,255,0.7);\n\n    font-size: 14px;\n\n    line-height: 1.6;\n}\n\n\n\n\n\n.comment-writer {\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 700;\n}\n\n\n\n\n\n.comment-date {\n\n    color:\n\n            rgba(255,255,255,0.55);\n\n    font-size: 13px;\n}\n\n\n\n\n\n.comment-action {\n\n    display: flex;\n\n    justify-content: flex-start;\n}\n\n\n\n\n\n.comment-delete-button {\n\n    min-width: 72px;\n\n    height: 40px;\n\n    border: none;\n\n    border-radius: 999px;\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #ff4d4d,\n                    #ff2f2f\n            );\n\n    color: white;\n\n    font-size: 13px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.comment-delete-button:hover {\n\n    transform: translateY(-2px);\n}\n\n\n\n\n\n/* =========================\n   페이지네이션\n========================= */\n\n.pagination-wrap {\n\n    display: flex;\n\n    justify-content: center;\n\n    align-items: center;\n\n    gap: 10px;\n\n    margin-top: 34px;\n\n    flex-wrap: wrap;\n}\n\n\n\n\n\n.page-button {\n\n    min-width: 44px;\n\n    height: 44px;\n\n    border-radius: 14px;\n\n    border:\n\n            1px solid\n            rgba(255,255,255,0.06);\n\n    background:\n\n            rgba(255,255,255,0.04);\n\n    color:\n\n            rgba(255,255,255,0.7);\n\n    font-size: 13px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: 0.25s;\n}\n\n\n\n\n\n.page-button.active {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #60a5fa\n            );\n\n    color: white;\n\n    border-color: transparent;\n}\n\n\n\n\n\n/* =========================\n   Tablet\n========================= */\n\n@media (max-width: 1024px) {\n\n    .comment-table-header,\n\n    .comment-row {\n\n        grid-template-columns:\n                60px\n                1.2fr\n                1.4fr\n                90px\n                140px\n                90px;\n    }\n}\n\n\n\n\n\n/* =========================\n   Mobile\n========================= */\n\n@media (max-width: 768px) {\n\n    .comment-search-input {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .comment-table-header {\n\n        display: none;\n    }\n\n\n\n\n\n    .comment-row {\n\n        display: flex;\n\n        flex-direction: column;\n\n        align-items: flex-start;\n\n        gap: 16px;\n\n        padding: 20px;\n    }\n\n\n\n\n\n    .comment-id {\n\n        font-size: 20px;\n    }\n\n\n\n\n\n    .comment-content {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .comment-post {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .comment-action {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .comment-delete-button {\n\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
